import { whatsappLinks } from "@/lib/whatsapp";

export default function WhatsAppButton() {
  const link = whatsappLinks.generic();
  return (
    <a
      href={link.href}
      onClick={link.onClick}
      target="_blank"
      rel="noreferrer"
      className="fixed bottom-20 left-4 sm:left-6 z-40 w-14 h-14 rounded-full bg-[#25D366] text-white hidden md:flex items-center justify-center shadow-2xl btn-lift hover:bg-[#1ebd5b]"
      data-testid="whatsapp-fab"
      aria-label="WhatsApp Kontakt"
    >
      <svg viewBox="0 0 32 32" className="w-7 h-7 fill-current" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.001 0C7.165 0 0 7.163 0 16c0 2.82.74 5.567 2.144 7.989L.001 32l8.21-2.137A15.97 15.97 0 0 0 16 32c8.836 0 16-7.163 16-16S24.836 0 16 0Zm0 29.333c-2.482 0-4.917-.667-7.04-1.928l-.504-.298-4.872 1.268 1.298-4.747-.328-.515A13.27 13.27 0 0 1 2.667 16C2.667 8.65 8.65 2.667 16 2.667 23.35 2.667 29.333 8.65 29.333 16c0 7.35-5.983 13.333-13.333 13.333Zm7.323-9.987c-.401-.2-2.374-1.171-2.741-1.305-.368-.134-.635-.2-.902.2-.267.402-1.034 1.305-1.268 1.572-.233.267-.467.301-.868.1-.401-.2-1.693-.624-3.227-1.99-1.192-1.064-1.997-2.378-2.231-2.78-.234-.4-.025-.617.176-.817.181-.18.401-.467.602-.7.2-.234.267-.402.4-.668.135-.267.067-.501-.033-.701-.1-.2-.902-2.176-1.236-2.978-.325-.78-.656-.674-.902-.687a16.04 16.04 0 0 0-.768-.013c-.267 0-.701.1-1.069.501-.368.4-1.402 1.37-1.402 3.34 0 1.97 1.436 3.875 1.636 4.142.2.267 2.824 4.314 6.846 6.05.957.413 1.703.66 2.286.844.96.305 1.834.262 2.524.16.77-.115 2.374-.97 2.708-1.907.334-.937.334-1.74.234-1.907-.1-.167-.367-.267-.768-.468Z"/>
      </svg>
    </a>
  );
}
